// Type guards ----------------------------------------------------------------
export const isRiskAnalysisOcrolusDocument = (analysis) => {
    return analysis.analyzableType === 'Integration::Ocrolus::Document';
};
export const isRiskAnalysisAlloyEntity = (analysis) => {
    return analysis.analyzableType === 'Integration::Alloy::Entity';
};
